import { UrlConfig } from 'config';
import { JSONObject } from 'models/Api/types';
import { ApiResponse } from 'models/Api/ApiResponse';
import { AjaxService } from 'services';
import { ProcessStatus } from 'models/types';
import { ItemDataSuggestionModel, PaginationModel } from 'models';
import { RawItemDataSuggestion } from 'models/ItemDataSuggestion/types';
import { RawPaginationData } from 'models/Pagination/Pagination';

export class ItemDataSuggestionApiClient {
  public static async createItemDataSuggestion(itemId: string, data: JSONObject): Promise<string> {
    const url = UrlConfig.ITEM_DATA_SUGGESTION.ITEM_DATA_SUGGESTION_CREATE;
    const response: ApiResponse<string> = await AjaxService.postData(url, {
      item_id: itemId,
      data: data
    });
    return response.data;
  }

  public static async getDetailedStatusSuggestions(status: ProcessStatus): Promise<PaginationModel<ItemDataSuggestionModel>> {
    const url = UrlConfig.ITEM_DATA_SUGGESTION.ITEM_DATA_SUGGESTION_DETAILED_STATUS + `${status}`;
    const response: ApiResponse<RawPaginationData<RawItemDataSuggestion>> = await AjaxService.getData(url);
    const paginatedResponse: PaginationModel<RawItemDataSuggestion> = new PaginationModel(response.data);
    const formattedSuggestions = paginatedResponse.data.map(
      (rawSuggestion: RawItemDataSuggestion) => new ItemDataSuggestionModel(rawSuggestion)
    );
    const formattedPaginatedResponse: PaginationModel<ItemDataSuggestionModel> = new PaginationModel({
      ...response.data,
      data: formattedSuggestions,
      fetched: true
    });
    return formattedPaginatedResponse;
  }

  public static async approveSuggestion(payload: { item_data_suggestion_id: string }): Promise<string> {
    const url = UrlConfig.ITEM_DATA_SUGGESTION.ITEM_DATA_SUGGESTION_APPROVE;
    const id = payload.item_data_suggestion_id;
    await AjaxService.postData(url, payload);
    return id;
  }

  public static async rejectSuggestion(payload: { item_data_suggestion_id: string }): Promise<string> {
    const url = UrlConfig.ITEM_DATA_SUGGESTION.ITEM_DATA_SUGGESTION_REJECT;
    const id = payload.item_data_suggestion_id;
    await AjaxService.postData(url, payload);
    return id;
  }
}
